import { render, staticRenderFns } from "./TrademarkJobCountList.vue?vue&type=template&id=dd984554&"
import script from "./TrademarkJobCountList.vue?vue&type=script&lang=js&"
export * from "./TrademarkJobCountList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkJobCountList.vue?vue&type=style&index=0&id=dd984554&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports